export const CONDITION_SEVERITY = {
  COMPENSATED: 'COMPENSATED',
  DECOMPENSATED: 'DECOMPENSATED',
  INACTIVE: 'INACTIVE'
}

export const CONDITION_SERIOUSNESS = {
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW'
}

export const GOAL_SEVERITY = {
  PAUSED: 'PAUSED',
  ONGOING: 'ONGOING',
  DONE: 'DONE'
}

export const GENERAL_DEMAND_TYPES = {
  CONDITION: 'CONDITION',
  GOAL: 'GOAL'
}

export const DEMAND_TYPES = {
  CID_10: 'CID_10',
  CIAP_2: 'CIAP_2',
  GOAL: 'GOAL'
}

export const DEMAND_TYPES_LABEL_MAP = {
  CID_10: 'Condição',
  CIAP_2: 'Condição',
  GOAL: 'Objetivo'
}

export const DEMAND_STATUS = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  PENDING: 'PENDING'
}

export const ACTION_RECOMMENDATIONS = {
  COMPENSATE: 'COMPENSATE',
  INACTIVATE: 'INACTIVATE'
}

export const DEMAND_TYPE_MAP = {
  [DEMAND_TYPES.CID_10]: 'CID',
  [DEMAND_TYPES.CIAP_2]: 'CIAP',
  [DEMAND_TYPES.GOAL]: 'GOAL'
}

export const CLASSIFICATION_DEMAND_TYPE_MAP = {
  CID: DEMAND_TYPES.CID_10,
  CIAP: DEMAND_TYPES.CIAP_2,
  GOAL: DEMAND_TYPES.GOAL
}

export const DEMAND_ICON_MAP = {
  [DEMAND_TYPES.CID_10]: 'icPulse',
  [DEMAND_TYPES.CIAP_2]: 'icPulse',
  [DEMAND_TYPES.GOAL]: 'icGoal'
}

export const GOAL_SEVERITY_OPTIONS = [
  {
    label: 'Em andamento',
    value: GOAL_SEVERITY.ONGOING,
    illustration: require('@/assets/demands/severity-ongoing.svg')
  },
  {
    label: 'Pausado',
    value: GOAL_SEVERITY.PAUSED,
    illustration: require('@/assets/demands/severity-paused.svg')
  },
  {
    label: 'Concluído',
    value: GOAL_SEVERITY.DONE,
    illustration: require('@/assets/demands/severity-done.svg')
  }
]

export const CONDITION_SEVERITY_OPTIONS = [
  {
    label: 'Compensada',
    value: CONDITION_SEVERITY.COMPENSATED,
    illustration: require('@/assets/user-mental.svg')
  },
  {
    label: 'Descompensada',
    value: CONDITION_SEVERITY.DECOMPENSATED,
    illustration: require('@/assets/user-mental-sad.svg')
  },
  {
    label: 'Inativa',
    value: CONDITION_SEVERITY.INACTIVE,
    illustration: require('@/assets/wind.svg')
  }
]

export const CONDITION_SERIOUSNESS_OPTIONS = [
  {
    label: 'Alta',
    value: CONDITION_SERIOUSNESS.HIGH
  },
  {
    label: 'Média',
    value: CONDITION_SERIOUSNESS.MEDIUM
  },
  {
    label: 'Baixa',
    value: CONDITION_SERIOUSNESS.LOW
  }
]

export const DEMANDS_SEVERITY_MAP = {
  [CONDITION_SEVERITY.COMPENSATED]: 'Compensada',
  [CONDITION_SEVERITY.DECOMPENSATED]: 'Descompensada',
  [CONDITION_SEVERITY.INACTIVE]: 'Inativa',
  [GOAL_SEVERITY.PAUSED]: 'Pausada',
  [GOAL_SEVERITY.ONGOING]: 'Em andamento',
  [GOAL_SEVERITY.DONE]: 'Finalizada'
}

export const DEFAULT_SEVERITY_MAP = {
  CID: CONDITION_SEVERITY.DECOMPENSATED,
  CIAP: CONDITION_SEVERITY.DECOMPENSATED,
  GOAL: GOAL_SEVERITY.ONGOING
}

export const DEMAND_STATUS_FILTER_OPTIONS = [
  {
    label: 'Pendente',
    value: DEMAND_STATUS.PENDING
  },
  {
    label: 'Validado',
    value: DEMAND_STATUS.ACTIVE
  }
]

export const DEMAND_STATUS_OPTIONS = [
  {
    label: 'Pendente',
    value: DEMAND_STATUS.PENDING
  },
  {
    label: 'Validado',
    value: DEMAND_STATUS.ACTIVE
  },
  {
    label: 'Cancelado',
    value: DEMAND_STATUS.CANCELLED
  }
]

export const DEMAND_ALERT_OPTIONS = [
  {
    label: 'Validação Pendente',
    value: DEMAND_STATUS.PENDING
  },
  {
    label: 'Condição Validada',
    value: DEMAND_STATUS.ACTIVE
  },
  {
    label: 'Recomendação · Compensar',
    value: ACTION_RECOMMENDATIONS.COMPENSATE
  },
  {
    label: 'Recomendação · Inativar',
    value: ACTION_RECOMMENDATIONS.INACTIVATE
  }
]
